import React from 'react';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAppDispatch } from '../../../../../app/hooks';
import { removeCondition } from '../../../state';

interface DeleteConditionButtonProps {
  index: number;
}

export const DeleteConditionButton: React.FC<DeleteConditionButtonProps> = ({ index }) => {
  const dispatch = useAppDispatch();

  return (
    <IconButton
      size="small"
      onClick={() => dispatch(removeCondition(index))}
      sx={{ color: '#ef4444' }}
    >
      <DeleteIcon fontSize="small" />
    </IconButton>
  );
};

export default DeleteConditionButton;
